<div fxLayout="column" fxFlexFill fxLayoutGap="24px">
    <div fxLayout="row" data-testid="signature-method-selection">
        <span class="signature-title m-l-xl" data-testid="select-signature-method-title">
            {{ "signature.selectSignatureMethod" | translate }}
        </span>
    </div>
    <div fxLayout="row" fxLayout.xs="column" fxFlex fxLayoutGap.xs="16px">
        <div
            fxHide.xs
            fxFlex="20"
            class="signature-container m-l-xl"
            fxLayout="column"
            fxLayoutAlign="start center"
            fxFlexOrder.xs="1">
            <!-- Draw mode: signature pad canvas -->
            <canvas
                #canvas
                (pointerdown)="padEmpty.set(false)"
                [style.display]="mode() === SignatureType.Draw ? 'block' : 'none'"
                width="250"
                height="120"
                class="canvas-container"
                data-testid="signature-canvas"></canvas>
            <!-- Type mode: text input rendered on canvas -->
            @if (mode() === SignatureType.Text) {
                <div class="canvas-container">
                    <input
                        class="typed-signature-input"
                        type="text"
                        [(ngModel)]="text"
                        [style.fontSize.px]="inputFontSize()"
                        [placeholder]="'actions.typeHere' | translate"
                        data-testid="typed-signature-input" />
                </div>
            }
            <!-- Image mode: file picker + cropper -->
            @if (mode() === SignatureType.Image) {
                <div fxLayout="column" fxLayoutGap="8px" class="image-upload-container">
                    <input
                        #fileInput
                        type="file"
                        accept="image/*"
                        style="display: none"
                        (change)="onFileSelected($event)"
                        data-testid="signature-file-input" />
                    @if (imageChangedEvent()) {
                        <image-cropper
                            [imageChangedEvent]="imageChangedEvent()"
                            [maintainAspectRatio]="true"
                            [aspectRatio]="250 / 120"
                            [resizeToWidth]="250"
                            [resizeToHeight]="120"
                            [output]="'base64'"
                            format="png"
                            (imageCropped)="onImageCropped($event)"
                            class="image-cropper"
                            data-testid="signature-image-cropper"></image-cropper>
                    }
                    <!-- Preview of already saved image signature -->
                    @if (!imageChangedEvent() && croppedImageBase64()) {
                        <img
                            [src]="'data:image/png;base64,' + croppedImageBase64()"
                            class="canvas-container"
                            alt="Signature"
                            data-testid="signature-image-preview" />
                    }
                    <button
                        mat-stroked-button
                        type="button"
                        (click)="fileInput.click()"
                        data-testid="upload-image-button">
                        {{ "signature.uploadImage" | translate }}
                    </button>
                </div>
            }
        </div>
        <div
            fxFlexOffset="10"
            fxFlex="40"
            fxLayout="column"
            fxLayoutGap="16px"
            fxLayoutAlign="start start"
            fxFlexOrder.xs="2">
            <mat-button-toggle-group
                fxLayout
                [(ngModel)]="mode"
                (change)="clearPad()"
                data-testid="signature-method-toggle">
                <mat-button-toggle [value]="SignatureType.Draw" data-testid="draw-button">
                    {{ "actions.draw" | translate }}
                </mat-button-toggle>
                <mat-button-toggle [value]="SignatureType.Text" data-testid="type-button">
                    {{ "actions.type" | translate }}
                </mat-button-toggle>
                <mat-button-toggle [value]="SignatureType.Image" data-testid="upload-button">
                    {{ "actions.upload" | translate }}
                </mat-button-toggle>
            </mat-button-toggle-group>
            <cipo-checkbox class="signature-checkbox" [control]="agreementControl" />
        </div>
    </div>
    <div fxLayout="row">
        <div fxFlex fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px" class="signature-buttons">
            <button mat-raised-button (click)="clearPad()" data-testid="clear-button">
                {{ "actions.clear" | translate }}
            </button>
            <button
                mat-raised-button
                [disabled]="disabledSave()"
                color="primary"
                (click)="savePad()"
                data-testid="save-button">
                {{ "actions.save" | translate }}
            </button>
        </div>
    </div>
</div>
